import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  timeLeft: undefined,
  timesLeft: [],
};

const slice = createSlice({
  name: 'testState',
  initialState,
  reducers: {
    setTimeLeft(state, action) {
      state.timesLeft = state.timesLeft.filter(t=>t.typeId != action.payload.typeId)
      state.timesLeft = state.timesLeft.concat(action.payload)
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    setTimeLeft,
} = slice.actions;